import { render } from "./FixedHeader.vue?vue&type=template&id=794fbf08&scoped=true&bindings={\"showFixedHeader\":\"data\",\"handleScroll\":\"options\",\"onButtonClick\":\"options\"}"
import script from "./FixedHeader.vue?vue&type=script&lang=js"
export * from "./FixedHeader.vue?vue&type=script&lang=js"

import "./FixedHeader.vue?vue&type=style&index=0&id=794fbf08&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-794fbf08"

export default script